module.exports = __webpack_public_path__ + "img/5273.28632a25.jpg";